import type { TourStep } from '../types';

export const supervisorReviewSteps: TourStep[] = [
  {
    target: '[data-tour="trainee-header"]',
    title: 'Supervisor Review',
    content:
      'As a supervisor, you review and approve your trainees\' experience log entries from this page. Let\'s walk through the approval workflow.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="trainee-selector"]',
    title: 'Select a Trainee',
    content:
      'If you supervise multiple trainees, switch between them here. Each shows their name, total hours, and how many entries need your review.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve selected one',
  },
  {
    target: '[data-tour="trainee-table"]',
    title: 'Review Entries',
    content:
      'Pending entries have a "Pending" badge. Click any entry to see the date, activity type, hours, property, and trainee notes.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="trainee-table"]',
    title: 'Approve or Request Revision',
    content:
      'For each entry: Approve to verify it (counts toward official hours), or Request Revision to send it back with feedback for the trainee to correct.',
    placement: 'top',
    isActionStep: true,
    spotlightClicks: true,
  },
];
